export const STANDARD_AD_DAYS = 3;
export const STANDARD_AD_PRICE = "3,000";

export const PREMIUM_AD_DAYS = 7;
export const PREMIUM_AD_PRICE = "10,000";
